// ui/notify.ts
import { useSnackbar, OptionsObject, VariantType } from 'notistack'

let enqueue: ((message: string, options?: OptionsObject) => void) | null = null

export const SnackbarBridge = (): null => {
  const { enqueueSnackbar } = useSnackbar()
  enqueue = enqueueSnackbar
  return null
}

const base = (
  message: string,
  variant: VariantType = 'default',
  options?: OptionsObject
): void => {
  if (!enqueue) return

  enqueue(message, {
    variant,
    autoHideDuration: 5000,
    ...(options || {}),
  })
}

export const notify = (message: string, options?: OptionsObject): void =>
  base(message, 'default', options)

export const notifyInfo = (message: string, options?: OptionsObject): void =>
  base(message, 'info', options)

export const notifyWarn = (message: string, options?: OptionsObject): void =>
  base(message, 'warning', options)

export const notifyError = (message: string, options?: OptionsObject): void =>
  base(message, 'error', options)

export const notifySuccess = (message: string, options?: OptionsObject): void =>
  base(message, 'success', options)
